<template>
  <div>


    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg5 class="head_contain">
            <p class="table_card__head--title">
              Counters
            </p>
          </v-flex>
          <v-flex xs12 lg7 class="filter_options">
            <v-flex class="right mr-20">
              <button
                class="faccess_button"
                @click="$router.push({name: 'new_counter'})"
              >
                Crear nuevo counter
              </button>
            </v-flex>
            <div
              class="buttom_reload"
              @click="getCounters()"
            >
              <img src="@/assets/img/icons/refresh-icon.svg">
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div>
        <v-flex class="ml-4 mt-4" xs4>
          <v-select
            label="Filtrar por locación"
            :items="locationArray"
            v-model="locationType"
          ></v-select>
        </v-flex>
        <v-data-table
          :headers="headers"
          :items="filteredCounters"
          class="elevation-1">
          <template slot="items" slot-scope="props" >
            <td @click="editItem(props.item)" style="cursor: zoom-in">{{ props.item.attributes.user.rut}}</td>
            <td @click="editItem(props.item)" style="cursor: zoom-in">{{ props.item.attributes.name+" "+props.item.attributes.last_name}}</td>
            <td @click="editItem(props.item)" style="cursor: zoom-in" v-if="props.item.attributes.user && props.item.attributes.user.email.length >=1">
              {{ props.item.attributes.user.email}}
            </td>
            <td @click="editItem(props.item)" style="cursor: zoom-in" v-else>
              -
            </td>
            <td @click="editItem(props.item)" style="cursor: zoom-in">
              {{ props.item.attributes.location.name}}
            </td>
            <td @click="editItem(props.item)" style="cursor: zoom-in">
              {{ props.item.attributes.enabled === false ? 'Deshabilitado' : 'Habilitado' }}
            </td>
            <td class="text-xs-center" style="white-space: nowrap;">
              <v-btn
                small
                depressed
                color="#FFC928"
                class="ma-0 mr-2 pa-0"
                style="min-width: 28px; width: 28px; height: 28px;"
                type="button"
                @click.stop="$router.push({ name: 'edit_counter', params: { id: props.item.id, counter: props.item } })"
              >
                <v-icon small class="white--text" style="font-size: 14px;">edit</v-icon>
              </v-btn>
              <v-btn
                v-if="props.item.attributes.enabled !== false"
                small
                depressed
                color="#FF6B6B"
                class="ma-0 pa-0"
                style="min-width: 28px; width: 28px; height: 28px;"
                type="button"
                @click.stop="openToggleEnabledDialog(props.item, false)"
              >
                <v-icon small class="white--text" style="font-size: 14px;">block</v-icon>
              </v-btn>
              <v-btn
                v-else
                small
                depressed
                color="#28a745"
                class="ma-0 pa-0"
                style="min-width: 28px; width: 28px; height: 28px;"
                type="button"
                @click.stop="openToggleEnabledDialog(props.item, true)"
              >
                <v-icon small class="white--text" style="font-size: 14px;">check_circle</v-icon>
              </v-btn>
            </td>
            <!-- <td>{{ props.item.attributes.send_date_time | moment("DD/MM/YYYY")}}</td>
            <td>{{ props.item.attributes.send_date_time | moment("hh:mm a")}}</td> -->
          </template>
        </v-data-table>
        <!-- <p>{{props.item.attributes.users}}</p> -->
        <v-dialog v-model="modal_details" max-width="30%">
          <!-- <v-btn slot="activator" color="primary" dark class="mb-2">New Item</v-btn> -->
          <v-card v-if="modal_details" class="table_card">
            <v-card-title class="table_card__head py-3">
              <span class="table_card__head--title">Visualizar counter</span>
            </v-card-title>
            <v-card-text style="padding: 0">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <span style="font-size: 12px; color: #5A6B8E">Rut</span>
                    <p style="font-size: 14px; margin-bottom: 0; font-weight: 500">
                      {{editedItem.attributes.user.rut}}
                    </p>
                  </v-flex>
                  <v-flex xs12>
                    <span style="font-size: 12px; color: #5A6B8E">Nombre</span>
                    <p style="font-size: 14px; margin-bottom: 0; font-weight: 500">
                      {{editedItem.attributes.name}}
                    </p>
                  </v-flex>
                  <v-flex xs12>
                    <span style="font-size: 12px; color: #5A6B8E">Apellido</span>
                    <p style="font-size: 14px; margin-bottom: 0; font-weight: 500">
                      {{editedItem.attributes.last_name}}
                    </p>
                  </v-flex>
                  <v-flex xs12>
                    <span style="font-size: 12px; color: #5A6B8E">Correo</span>
                    <p style="font-size: 14px; margin-bottom: 0; font-weight: 500">
                      {{editedItem.attributes.user.email}}
                    </p>
                  </v-flex>
                  <v-flex xs12>
                    <span style="font-size: 12px; color: #5A6B8E">Locación</span>
                    <p style="font-size: 14px; margin-bottom: 0; font-weight: 500">
                      {{editedItem.attributes.location.name}}
                    </p>
                  </v-flex>
                  <!--<v-flex xs12>
                    <span style="font-size: 12px; color: #89899B">Cuerpo</span>
                    <p style="font-size: 14px; margin-bottom: 0; max-height: 170px;overflow-y: scroll;padding: 25px 36px;border: 1px dotted #89899B;"
                      v-html="editedItem.attributes.message">
                    </p>
                  </v-flex>
                  <v-flex xs5 v-if="editedItem.attributes.users.length > 0">
                  <span style="font-size: 12px; color: #89899B">Correos registrados ({{editedItem.attributes.users.length}})</span>
                  <div
                    style="max-height: 125px; overflow-x: hidden; overflow-y: auto"
                    >
                    <p
                      v-for="(user,index) in editedItem.attributes.users"
                      :key="index"
                      style="font-size: 14px; margin-bottom: 0">
                      {{user}}
                    </p>
                  </div>
                  </v-flex>
                  <v-flex xs2 v-if="editedItem.attributes.users.length > 0">
                  </v-flex>
                  <v-flex xs5 v-if="editedItem.attributes.unregistered_users.length > 0">
                    <span style="font-size: 12px; color: #89899B">Correos sin registro ({{editedItem.attributes.unregistered_users.length}})</span>
                    <div
                    style="max-height: 125px; overflow-x: hidden; overflow-y: auto"
                    >
                    <p
                      v-for="(unregistered_user,index) in editedItem.attributes.unregistered_users"
                      :key= index
                      style="font-size: 14px; margin-bottom: 0">
                      {{unregistered_user}}
                    </p>
                    </div>
                  </v-flex>-->
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#5A6B8E" flat @click.native="close()">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="toggle_enabled_modal" max-width="420">
          <v-card class="table_card">
            <v-card-title class="table_card__head py-3">
              <span class="table_card__head--title">{{ toggleModalTitle }}</span>
            </v-card-title>
            <v-card-text style="padding: 20px 24px;">
              <p style="font-size: 15px; margin-bottom: 0;">
                {{ toggleModalMessage }}
              </p>
            </v-card-text>
            <v-card-actions style="padding: 0 24px 20px;">
              <v-spacer></v-spacer>
              <v-btn color="#5A6B8E" flat @click="closeToggleEnabledDialog">
                Cancelar
              </v-btn>
              <v-btn
                :color="toggleConfirmColor"
                class="white--text"
                depressed
                :loading="toggleSubmitting"
                :disabled="toggleSubmitting"
                @click="confirmToggleEnabledCounter"
              >
                {{ toggleConfirmLabel }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>


  </div>


</template>

<script>
/* Listado: GET counters. Borrar/deshabilitar en diálogo aún sin endpoint acordado (p. ej. DELETE counters/:id). */
export default {
  data () {
    return {
      modal_details: false,
      myCounters: [],
      headers: [
          { text: 'Rut', value: 'rut', sortable: false},
          { text: 'Nombre', value: 'userName', sortable: false },
          { text: 'Correo', sortable: false, value: 'email' },
          { text: 'Locación', value: 'location', sortable: false },
          { text: 'Estado', value: 'enabled', sortable: false },
          { text: 'Acciones', value: 'actions', sortable: false },


      ],
      editedItem: {
        attributes:{
          rut:'',
          userName: '',
          email: [],
          location:''
        }
      },
      defaultItem: {
        attributes:{
          rut:'',
          userName: '',
          email: [],
          location:''
        }
      },
      editedIndex: -1,
      locationType:'',
      locationArray:[],
      toggle_enabled_modal: false,
      counterPendingToggle: null,
      pendingEnabledValue: true,
      toggleSubmitting: false
    }
  },
  computed:{
    filteredCounters(){
      return this.myCounters.filter((i) => {
        return !this.locationType || (i.attributes.location.name === this.locationType) || this.locationType=="Todas las locaciones";
      })
    },
    toggleModalTitle () {
      return this.pendingEnabledValue ? 'Confirmar habilitación' : 'Confirmar deshabilitación'
    },
    toggleModalMessage () {
      return this.pendingEnabledValue
        ? '¿Está seguro de que desea habilitar esta cuenta de counter? Podrá iniciar sesión nuevamente.'
        : '¿Está seguro de que desea deshabilitar esta cuenta? No podrá iniciar sesión hasta que sea habilitada de nuevo.'
    },
    toggleConfirmColor () {
      return this.pendingEnabledValue ? '#28a745' : '#FF6B6B'
    },
    toggleConfirmLabel () {
      return this.pendingEnabledValue ? 'Habilitar' : 'Deshabilitar'
    }
  },
  mounted(){
    this.getCounters();
  },
  methods: {
    getCounters(){
      try {
        this.$http.get('counters',{
          headers:{
            "X-Device-ID": this.getDeviceId(),
            "Authorization": 'Bearer ' + this.getUserToken()
          }
        })
        .then(function(response){
          console.log("ANSWER")
          // console.log(response)
          this.myCounters = response.body.data
          console.log(this.myCounters);
          let temp=this.myCounters.map(function(elem) {
              return elem.attributes.location.name;
          })
          temp.unshift("Todas las locaciones")
          this.locationArray=[...new Set(temp)]
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          // console.log(response);
          // if(typeof response.body.errors[0].details != "object"){
          //   alert(response.body.errors[0].details);
          // }else{
          //   let message = []
          //   for(var key in response.body.errors[0].details){
          //     message.push(response.body.errors[0].details[key])
          //   }
          //   alert(message);
          // }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    editItem (item) {
      this.editedIndex = this.myCounters.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.modal_details = true
    },
    close () {
      this.modal_details = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    openToggleEnabledDialog (item, enabledAfterConfirm) {
      this.counterPendingToggle = item
      this.pendingEnabledValue = enabledAfterConfirm
      this.toggle_enabled_modal = true
    },
    closeToggleEnabledDialog () {
      this.toggle_enabled_modal = false
      this.counterPendingToggle = null
    },
    confirmToggleEnabledCounter () {
      const item = this.counterPendingToggle
      const enabled = this.pendingEnabledValue
      if (!item || !item.id) {
        this.closeToggleEnabledDialog()
        return
      }
      const loc = item.attributes.location || {}
      const user = item.attributes.user || {}
      const payload = {
        id: item.id,
        attributes: {
          name: item.attributes.name,
          last_name: item.attributes.last_name,
          location_id: loc.id != null ? loc.id : null,
          email: user.email,
          rut: user.rut,
          company: this.getCompany().id,
          enabled: enabled
        }
      }
      const headers = {
        'X-Device-ID': this.getDeviceId(),
        Authorization: 'Bearer ' + this.getUserToken()
      }
      this.toggleSubmitting = true
      this.$http
        .patch('counters/' + item.id, { data: this.encrypt(payload).toString() }, { headers })
        .then((response) => {
          if (response.body.meta && response.body.meta.authentication_token) {
            this.checkToken(response.body.meta.authentication_token)
          }
          this.closeToggleEnabledDialog()
          this.getCounters()
        })
        .catch((response) => {
          if (response.body && response.body.meta && response.body.meta.authentication_token) {
            this.checkToken(response.body.meta.authentication_token)
          }
          if (response.body && response.body.errors && response.body.errors[0]) {
            const err = response.body.errors[0]
            alert(typeof err.details === 'object' ? JSON.stringify(err.details) : (err.details || err.title || 'Error'))
          } else {
            alert(enabled ? 'No se pudo habilitar el counter' : 'No se pudo deshabilitar el counter')
          }
        })
        .then(() => {
          this.toggleSubmitting = false
        }, () => {
          this.toggleSubmitting = false
        })
    }
  },

}
</script>



// WEBPACK FOOTER //
// src/components/views/access/counter/CounterIndex.vue